import type { RouteObject } from "react-router";
import MeetingRoomPage from "./ui/pages/MeetingRoomPage";
import PublicCancelAppointmentPage from "./ui/pages/PublicCancelAppointmentPage";
import SchedulerCalendarPage from "./ui/pages/SchedulerCalendarPage";
import SchedulerOAuthCallbackPage from "./ui/pages/SchedulerOAuthCallbackPage";

/**
 * The room a booking is held in. Outside `AppLayout` for the same reason as
 * the session rooms: a call in progress does not share the screen with the
 * app's navigation.
 *
 * Deliberately not under /scheduler — the URL is what a booking's meeting link
 * points at.
 */
export const schedulerMeetingRoutes: RouteObject[] = [
    { path: "/meet/:appointmentId", element: <MeetingRoomPage /> },
];

/**
 * Opened from the link in an appointment email, by a patient with no account.
 * Outside the app shell and any auth guard: the signed link is the permission.
 * The token travels in the fragment, which browsers never send to a server.
 */
export const schedulerPublicRoutes: RouteObject[] = [
    { path: "/appointments/cancel", element: <PublicCancelAppointmentPage /> },
];

export const schedulerRoutes: RouteObject[] = [
    { path: "/scheduler", element: <SchedulerCalendarPage /> },
    // Where Zoom and Google redirect back after consent. This exact path must
    // be registered as an authorized redirect URI with both providers.
    { path: "/scheduler/oauth/:provider", element: <SchedulerOAuthCallbackPage /> },
];
